import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { getImagePathResolved } from '@Actions/images.actions';
import { ImagePathStoreState } from '@Types/images.types';

export const initialState: ImagePathStoreState = {
	imagesPath: [],
};

interface ImagePath {
	[x: string]: (
		state: ImagePathStoreState,
		action: AnyAction,
	) => ImagePathStoreState | undefined;
}

const reducer: ImagePath = {
	// stats
	[getImagePathResolved.toString()]: (state, action) => ({
		...state,
		imagesPath: [...state.imagesPath, action.payload],
	}),
};

export default createReducer(initialState, reducer);
